import { StyleSheet } from 'react-native';
import { font_weight_normal, input_size_border_width, input_size_container_default_width, input_size_container_large_height, input_size_container_mini_height, input_size_container_small_height, input_size_font, input_size_icon_height, input_size_icon_margin_left, input_size_arrow, input_size_clear, } from '../../styles/vars/size';
import { useTheme } from '../../hooks/useTheme';
import { useStyleVars } from '../../hooks/useStyleVars';
import { input_size_icon_width } from '../../styles/vars/size';
export function useStyle({ kidtoken, scalable, customStyle, }) {
    const { theme } = useTheme();
    const { inputFontSize, inputFontWeight, inputHeight, inputWidth, inputTextColor, inputPlaceHolderTextColor, } = customStyle;
    const { kibt_cs_common_background_white, kibt_cs_common_text_black, kibt_cs_common_text_describe, kibt_cs_common_text_quaternary, kibt_cs_common_text_primary, kibt_cs_common_stroke_border, kibt_cs_common_background_grayprimaryreal, } = theme;
    const customVars = {
        kid_input_color_content_font: inputTextColor,
        kid_input_color_placeholder_font: inputPlaceHolderTextColor,
        kid_input_size_container_mini_height: inputHeight,
        kid_input_size_container_small_height: inputHeight,
        kid_input_size_container_large_height: inputHeight,
        kid_input_size_container_width: inputWidth,
        kid_input_size_font: inputFontSize,
        kid_input_font_weight: inputFontWeight,
    };
    const defaultVars = {
        // 颜色变量
        kid_input_color_background: kibt_cs_common_background_white,
        kid_input_color_content_font: kibt_cs_common_text_black,
        kid_input_color_right_font: kibt_cs_common_text_quaternary,
        kid_input_color_border: kibt_cs_common_stroke_border,
        kid_input_color_word_limit_font: kibt_cs_common_text_primary,
        kid_input_color_placeholder_font: kibt_cs_common_text_describe,
        kid_input_color_arrow_icon: kibt_cs_common_background_grayprimaryreal,
        // 尺寸变量
        kid_input_size_container_width: input_size_container_default_width,
        kid_input_size_container_mini_height: input_size_container_mini_height,
        kid_input_size_container_small_height: input_size_container_small_height,
        kid_input_size_container_large_height: input_size_container_large_height,
        kid_input_size_font: input_size_font,
        kid_input_size_icon_width: input_size_icon_width,
        kid_input_size_icon_height: input_size_icon_height,
        kid_input_font_weight: font_weight_normal,
        kid_input_size_icon_margin_left: input_size_icon_margin_left,
        kid_input_size_border_width: input_size_border_width,
        // 传给子组件customStyle的尺寸
        kid_input_size_arrow_icon_custom: input_size_arrow,
        kid_input_size_clear_icon_custom: input_size_clear,
    };
    const vars = useStyleVars({
        defaultVars,
        customVars,
        scalable,
        kidtoken,
    });
    return {
        vars,
        style: StyleSheet.create({
            inputWrap: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                backgroundColor: vars.kid_input_color_background,
                height: vars.kid_input_size_container_small_height,
                width: vars.kid_input_size_container_width,
            },
            common: {
                width: '100%',
                height: '100%',
                flex: 1,
                color: vars.kid_input_color_content_font,
                fontSize: vars.kid_input_size_font,
                fontWeight: vars.kid_input_font_weight,
            },
            disabled: {
                opacity: 0.5,
            },
            border: {
                borderBottomColor: vars.kid_input_color_border,
                borderBottomWidth: vars.kid_input_size_border_width,
            },
            suffix: {
                flexShrink: 0,
                backgroundColor: vars.kid_input_color_background,
                flexDirection: 'row',
                alignItems: 'center',
            },
            clear: {
                marginLeft: vars.kid_input_size_icon_margin_left,
            },
            arrow: {
                width: vars.kid_input_size_icon_width,
                height: vars.kid_input_size_icon_height,
                marginLeft: vars.kid_input_size_icon_margin_left,
            },
            limitWrap: {
                flexShrink: 0,
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: vars.kid_input_size_icon_margin_left,
                flexDirection: 'row',
            },
            inputLength: {
                color: vars.kid_input_color_right_font,
            },
            inputLengthLimit: {
                color: vars.kid_input_color_word_limit_font,
            },
            maxLength: {
                color: vars.kid_input_color_right_font,
            },
            mini: {
                height: vars.kid_input_size_container_mini_height,
            },
            large: {
                height: vars.kid_input_size_container_large_height,
            },
            small: {
                height: vars.kid_input_size_container_small_height,
            },
        }),
    };
}
